// extracted by mini-css-extract-plugin
export default {"room":"room--Kxi4C","participant":"participant--QT5cN"};